import { Colors, Sizes } from '@/components/ui/types';
import { Nullable } from '@/models/Model';

export const TIME_DIRECTIONS = ['past', 'next', 'this'] as const;
export type TimeDirection = (typeof TIME_DIRECTIONS)[number];

export const TIME_GRANULARITIES = ['day', 'week', 'month', 'year'] as const;
export type TimeGranularity = (typeof TIME_GRANULARITIES)[number];

export type DiscreteValue = {
  direction: TimeDirection;
  granularity: TimeGranularity;
  amount?: number;
};

export type ComplexDateOutputValue =
  | { type: 'range'; dateFrom: string; dateTo: string }
  | { type: 'single'; date: string }
  | ({ type: 'discrete'; dateFrom: string; dateTo: string } & DiscreteValue);

export type DateRangeValue = {
  startDate: Nullable<Date>;
  endDate: Nullable<Date>;
};

export type DiscreteDateLabels = {
  directions: Record<TimeDirection, string>;
  granularities: Record<TimeGranularity, string>;
  granularitiesThis: Record<TimeGranularity, string>;
  directionAriaLabel: string;
  amountAriaLabel: string;
  granularityAriaLabel: string;
};

export type InternalState = {
  mode: 'discrete' | 'picker';
  discrete?: DiscreteValue;
  dateRange: DateRangeValue;
};

export type ComplexDateInputClassNames = {
  base?: string;
  input?: string;
  panel?: string;
};

export type ComplexDateInputProps = {
  value: Nullable<ComplexDateOutputValue>;
  onChange: (value: Nullable<ComplexDateOutputValue>) => void;
  placeholder?: string;
  disabled?: boolean;
  clearable?: boolean;
  error?: boolean;
  size?: Sizes;
  color?: Colors;
  forceOpen?: boolean;
  closeLabel?: string;
  dividerLabel?: string;
  clearAriaLabel?: string;
  discreteLabels?: DiscreteDateLabels;
  classNames?: ComplexDateInputClassNames;
};

export type DiscreteDateInputProps = {
  value: Nullable<DiscreteValue>;
  onChange: (value: DiscreteValue) => void;
  disabled?: boolean;
  size?: Sizes;
  labels?: DiscreteDateLabels;
};

export type GeneralDatePickerProps = {
  value: Nullable<DateRangeValue>;
  onChange: (value: DateRangeValue) => void;
  disabled?: boolean;
};
